import { SetConfigs } from './config.actions';
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AppConfigStateModel, AuthConfig, ContactDetails, ErrorHandlerConfig } from 'src/app/model';

@State<AppConfigStateModel>({
  name: 'appConfig',
  defaults: {
    production: false,
    auth: null,
    baseApiUrl: '',
    authorizationTokensUrl: '',
    environment: '',
    errorHandlerConfig: null,
    contactDetails: {
      slackChannelLink: '',
      dicAdminEmail: '',
    },
  },
})
@Injectable()
export class ConfigState {
  @Selector()
  static appConfigs(state: AppConfigStateModel): AppConfigStateModel {
    return state;
  }

  @Selector()
  static contactDetails(state: AppConfigStateModel): ContactDetails {
    return state?.contactDetails;
  }

  @Selector()
  static authConfigs(state: AppConfigStateModel): AuthConfig {
    return state.auth;
  }

  @Selector()
  static errorHandlerConfigs(state: AppConfigStateModel): ErrorHandlerConfig {
    return state.errorHandlerConfig;
  }

  @Selector()
  static baseApiUrl(state: AppConfigStateModel): string {
    return state.baseApiUrl;
  }

  @Selector()
  static authorizationTokensUrl(state: AppConfigStateModel): string {
    return state.authorizationTokensUrl;
  }

  @Action(SetConfigs)
  setConfigs({ getState, patchState }: StateContext<AppConfigStateModel>, { payload }): void {
    patchState({
      ...getState(),
      ...payload,
    });
  }
}
